import { render, staticRenderFns } from "./PendingPaymentsSchool.vue?vue&type=template&id=7d4c0397"
import script from "./PendingPaymentsSchool.vue?vue&type=script&lang=js"
export * from "./PendingPaymentsSchool.vue?vue&type=script&lang=js"
import style0 from "./PendingPaymentsSchool.vue?vue&type=style&index=0&id=7d4c0397&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports